import { render } from "./MediaPropertyEdit.vue?vue&type=template&id=4252902d&scoped=true"
import script from "./MediaPropertyEdit.vue?vue&type=script&lang=js"
export * from "./MediaPropertyEdit.vue?vue&type=script&lang=js"

import "./MediaPropertyEdit.vue?vue&type=style&index=0&id=4252902d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4252902d"],['__file',"src/components/mediaproperty/MediaPropertyEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4252902d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4252902d', __exports__)) {
    api.reload('4252902d', __exports__)
  }
  
  module.hot.accept("./MediaPropertyEdit.vue?vue&type=template&id=4252902d&scoped=true", () => {
    api.rerender('4252902d', render)
  })

}


export default __exports__